import React from 'react'
import PropTypes from 'prop-types'

/**
 * A component which acts as stub for the `Script` component, which loads the
 * Messenger Extensions SDK. This stub only calls `window.extAsyncInit()` to
 * simulate the original behavior.
 * This implements also the PropTypes of react-load-script to catch errors, but
 * it doesn't use them.
 */
export default class StubScript extends React.PureComponent {
  static propTypes = {
    /**
     * From react-load-script: Called in case of an error with the script.
     */
    onError: PropTypes.func.isRequired,
    /**
     * From react-load-script: Called when the requested script is fully loaded.
     */
    onLoad: PropTypes.func.isRequired,
    /**
     * From react-load-script: URL pointing to the script you want to load.
     */
    url: PropTypes.string.isRequired
  }

  componentDidMount() {
    setTimeout(() => window.extAsyncInit())
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/facebook/StubScript.js